var _AlertCircle, _CloseSmall, _Settings;
import { Fragment } from 'react';
import AlertCircle from '@crehana/icons/fill/AlertCircle';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import Settings from '@crehana/icons/outline/Settings';
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LowQualityWarning = function LowQualityWarning(_ref) {
  var onDismiss = _ref.onDismiss;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center justify-between mb-16",
      children: [/*#__PURE__*/_jsxs("p", {
        className: "flex items-center text-yellow-lighter font-subtitle2",
        children: [_AlertCircle || (_AlertCircle = /*#__PURE__*/_jsx(AlertCircle, {
          className: "text-yellow-main fill-current flex-shrink-0 mr-8",
          size: 24,
          ignoreColor: true
        })), t('LOW_QUALITY_WARNING_TITLE')]
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onDismiss,
        className: "button-base text-base-lighter flex-shrink-0",
        "aria-label": t('CLOSE'),
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          className: "fill-current flex-shrink-0",
          size: 24,
          ignoreColor: true
        }))
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "font-body3 text-white mb-12",
      children: t('LOW_QUALITY_WARNING_DESCRIPTION')
    }), /*#__PURE__*/_jsxs("p", {
      className: "font-subtitle4 text-gray-main flex items-center",
      children: [t('LOW_QUALITY_WARNING_CTA'), _Settings || (_Settings = /*#__PURE__*/_jsx(Settings, {
        className: "fill-current flex-shrink-0 ml-4",
        size: 16,
        ignoreColor: true
      }))]
    })]
  });
};
export default LowQualityWarning;